import SysColumn from "app/class/sys-column";
import SysTable from "app/class/sys-table";
import { PERMISSION_ARRAY_FIELD_TYPE } from "../components/record-producer-fields/permission-array-field/types";
import { resolvePermissionFieldProfile } from "../components/record-producer-fields/permission-array-field/resolvePermissionFieldProfile";

const TABLE_NAME_FIELD_TYPE = "TABLE_NAME";

interface ResolveRecordProducerFieldTypeInput {
    table: SysTable;
    column: SysColumn;
}

export const resolveRecordProducerFieldType = ({ table, column }: ResolveRecordProducerFieldTypeInput) => {
    if (column.column_type === TABLE_NAME_FIELD_TYPE) {
        return TABLE_NAME_FIELD_TYPE;
    }

    if (table.name === "sys_columns" && ["referenced_table_name", "reference_table_name"].includes(column.name)) {
        return TABLE_NAME_FIELD_TYPE;
    }

    if (column.column_type === PERMISSION_ARRAY_FIELD_TYPE) {
        return PERMISSION_ARRAY_FIELD_TYPE;
    }

    if (resolvePermissionFieldProfile({ table, column })) {
        return PERMISSION_ARRAY_FIELD_TYPE;
    }

    return column.column_type;
};
